import { NewspaperIcon } from "@heroicons/react/outline";
import { PencilIcon } from "@heroicons/react/solid";
import { useOne, useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import Button from "components/button";
import { DescriptionItem } from "components/descriptionItem";
import { FullScreenLoading } from "components/fullScreenLoading";
import { IConditionDetail } from "interfaces";
import { useState } from "react";
import { Link } from "react-router-dom";
import { isHaveActionPermission } from "utills/helpers";

export const ConditionDetail: React.FC = () => {

  const parse = useParse();
  const { params } = parse();
  const [contentLanguage, setContentLanguage] = useState("vi");
  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IConditionDetail>({
    resource: "content/about-us",
    id: `${params?.id}/detail`,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const conditionDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="w-full flex flex-col items-center gap-y-3 sm:gap-y-4">
      <Breadcrumbs
        {...(isHaveActionPermission("about_actiup", "other", "edit") && {
          additionalLabel: (
            <Link to={`/other/about-actiup/${conditionDetailData?.id}/edit`}>
              <Button>
                <span className="sr-only">Edit</span>
                <PencilIcon className="w-4 h-4 text-white" />{" "}
                <span className="hidden sm:block sm:ml-2">Edit</span>
              </Button>
            </Link>
          ),
        })}
      />
      <div className="box-container">
        <p className="font-bold text-xl">{conditionDetailData?.title_vi}</p>
      </div>
      <div className="w-full">
        <div>
          <button 
            className={`px-4 py-2 rounded-tl-md rounded-tr-md border-magnolia-600 border-solid border-[1px] ${contentLanguage === "vi" ? "bg-gray-300" : "bg-white"}`} 
            onClick={() => setContentLanguage("vi")}
          >
            Vietnam
          </button>
          <button 
            className={`px-4 py-2 rounded-tl-md rounded-tr-md border-magnolia-600 border-solid border-[1px] ${contentLanguage === "en" ? "bg-gray-300" : "bg-white"}`}
            onClick={() => setContentLanguage("en")}
          >
            English
          </button>
        </div>
        <div className="box-container p-0 divide-y divide-gray-100">
          <DescriptionItem 
            icon={NewspaperIcon}
            label="Title"
            content={(
              <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                {contentLanguage === "vi" ? conditionDetailData?.title_vi : conditionDetailData?.title_en}
              </p>
            )}
          />
          <DescriptionItem 
            icon={NewspaperIcon}
            label="Content"
            content={(
              <div className="reset-tw" dangerouslySetInnerHTML={{
                __html: `${contentLanguage === "vi" ? conditionDetailData?.content_vi : conditionDetailData?.content_en}`
              }}>
              </div>
            )}
          />
        </div>
      </div>
      {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
    </div>
  );
}